<template>
  <div
    align="center"
    class="fill-height mt-6"
    id="signature-div"
  >
    <v-container
      fluid
      class="container-width"
    >

      <p class="title"><strong>DECLARAÇÃO DE CREDENCIADO</strong></p>
      <div
      class="subtitle-1 mb-8"
    >
        Falta pouco para você ser um Credenciado Horus. clique no botão <b>Assinar</b> ao final desta página e comece a faturar!
    </div>
    </v-container>
    <div>

    </div>
  </div>

</template>

<script>
  import {GET_NAME, GET_EMAIL, GET_BIRTHDATE, GET_CPF, GET_UUID_DOCUMENT, GET_KEY_SIGNER} from "../../store/modules/flight-provider"
  import {mapGetters} from "vuex";
  import moment from "moment"

  export default {
    name: "AccreditationSignature",

    computed: {
      ... mapGetters({
        name: GET_NAME,
        email: GET_EMAIL,
        birthdate: GET_BIRTHDATE,
        cpf: GET_CPF,
        uuidDoc: GET_UUID_DOCUMENT,
        keySigner: GET_KEY_SIGNER,
      })
    },

    mounted() {
      this.$appMng.setTitle("Serviços")

      let birthdate = moment(this.birthdate)

      window.d4sign.configure({
        container: "signature-div",
        key: this.uuidDoc,
        protocol: "https",
        host: "secure.d4sign.com.br/embed/viewblob",
        signer: {
          email: this.email,
          display_name: this.name,
          documentation: this.cpf,
          birthday: birthdate.format("DD/MM/YYYY"),
          disable_preview: "0",
          key_signer: this.keySigner
        },
        width: 0.85*(window.innerWidth),
        height: 0.5*(window.innerHeight),
        callback: function (event) {
          if (event.data === "signed") {
            alert('ASSINADO');
          }
        }
      })
    },
  }
</script>

<style scoped lang="scss">

  .stepper-width {
    min-width: 100%;
  }

  .container-width {
    min-width: 80%;
    max-width: 80%;
  }

</style>